export default __webpack_public_path__ + "static/Phalecia Anderson-7d50c44db90d9c7ed46746fd70c38579.jpg";